import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "./index";
import Navbar from "./components/Navbar";
import CardList from "./components/CardList";
import CardView from "./components/CardView";
import TournamentResults from "./components/TournamentResults";
import MetagameBreakdown from "./components/MetagameBreakdown";
import Prices from "./components/Prices";
import DeckView from "./components/DeckView";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, "screen_view", {
      screen_name: location.pathname,
    });
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <Navbar />
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<CardList />} />
        <Route path="/card/:id" element={<CardView />} />
        <Route path="/tournament-results" element={<TournamentResults />} />
        <Route path="/metagame-breakdown" element={<MetagameBreakdown />} />
        <Route path="/deck-view/:archetype" element={<DeckView />} />
        {/* <Route path="/prices" element={<Prices />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
